import { useTranslation } from 'react-i18next';
import { useTypedParams } from 'react-router-typesafe-routes';
import PageLayout from '@/components/layouts/page-layout/page-layout';
import LoadingLayout from '@/components/layouts/progress-layout/loading-layout';
import CommonGroupBlock from '@/components/user/common-group-block';
import useFriendInfo from '@/hooks/users/use-friend-info';
import ROUTES from '@/routes';

export default function CommonGroupsRoute() {
  const { t } = useTranslation();
  const { userId } = useTypedParams(ROUTES.CONTACT.USERS.BY_ID);
  const { friendInfo, isLoading } = useFriendInfo(userId);

  return (
    <PageLayout
      title={t('user.same-group')}
      headerConfig={{
        navigateBack: true,
      }}>
      <LoadingLayout promise={isLoading}>
        {() => (
          <div className='flex flex-1 flex-col items-stretch'>
            <CommonGroupBlock
              itemClassName='px-5'
              groups={friendInfo?.CommonGroup ?? []}
            />
          </div>
        )}
      </LoadingLayout>
    </PageLayout>
  );
}
